import { render, staticRenderFns } from "./DialogGrantPoints.vue?vue&type=template&id=42fabe2a&"
import script from "./DialogGrantPoints.vue?vue&type=script&lang=js&"
export * from "./DialogGrantPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports